import { useEffect, useState } from 'react';

const gold = '#C8A96E';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className="back-btn-desktop"
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '40px',
        zIndex: 40,
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: 'none',
        background: '#1A1916',
        boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        transition: 'background 0.2s, box-shadow 0.2s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = '#333';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.28)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = '#1A1916';
        e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.18)';
      }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 15l-6-6-6 6" />
      </svg>
    </button>
  );
};

export default BackToTop;
